import Vue from 'vue'
import Router from 'vue-router'
const homeWeb = resolve => require(['@/components/homeWeb'], resolve)
const aboutus = resolve => require(['@/components/aboutus'], resolve)
const enterpriseNews = resolve => require(['@/components/enterpriseNews'], resolve)
const intelligent = resolve => require(['@/components/intelligent'], resolve)
const joinus = resolve => require(['@/components/joinus'], resolve)
const newsa = resolve => require(['@/components/newsDetail/news1'], resolve)
const newsb = resolve => require(['@/components/newsDetail/news2'], resolve)
const newsc = resolve => require(['@/components/newsDetail/news3'], resolve)
const newsd = resolve => require(['@/components/newsDetail/news4'], resolve)
const newse = resolve => require(['@/components/newsDetail/news5'], resolve)
const newsf = resolve => require(['@/components/newsDetail/news6'], resolve)
const newsg = resolve => require(['@/components/newsDetail/news7'], resolve)
const newsh = resolve => require(['@/components/newsDetail/news8'], resolve)
const newsi = resolve => require(['@/components/newsDetail/news9'], resolve)
const newsj = resolve => require(['@/components/newsDetail/news10'], resolve)
const newsk = resolve => require(['@/components/newsDetail/news11'], resolve)
const newsl = resolve => require(['@/components/newsDetail/news12'], resolve)
const newsm = resolve => require(['@/components/newsDetail/news13'], resolve)
const newsn = resolve => require(['@/components/newsDetail/news14'], resolve)
const newso = resolve => require(['@/components/newsDetail/news15'], resolve)
const newsp = resolve => require(['@/components/newsDetail/news16'], resolve)
const newsq = resolve => require(['@/components/newsDetail/news17'], resolve)
const newsr = resolve => require(['@/components/newsDetail/news18'], resolve)
const newss = resolve => require(['@/components/newsDetail/news19'], resolve)
const newst = resolve => require(['@/components/newsDetail/news20'], resolve)
const newsu = resolve => require(['@/components/newsDetail/news21'], resolve)
const newsv = resolve => require(['@/components/newsDetail/news22'], resolve)
const newsw = resolve => require(['@/components/newsDetail/news23'], resolve)
const newsx = resolve => require(['@/components/newsDetail/news24'], resolve)
const newsy = resolve => require(['@/components/newsDetail/news25'], resolve)
const newsz = resolve => require(['@/components/newsDetail/news26'], resolve)

const newsEna = resolve => require(['@/components/newsDetail/newsEn1'], resolve)
const newsEnb = resolve => require(['@/components/newsDetail/newsEn2'], resolve)
const newsEnc = resolve => require(['@/components/newsDetail/newsEn3'], resolve)
const newsEnd = resolve => require(['@/components/newsDetail/newsEn4'], resolve)
const newsEne = resolve => require(['@/components/newsDetail/newsEn5'], resolve)
const newsEnf = resolve => require(['@/components/newsDetail/newsEn6'], resolve)
const newsEng = resolve => require(['@/components/newsDetail/newsEn7'], resolve)
const newsEnh = resolve => require(['@/components/newsDetail/newsEn8'], resolve)
const newsEni = resolve => require(['@/components/newsDetail/newsEn9'], resolve)
const newsEnj = resolve => require(['@/components/newsDetail/newsEn10'], resolve)
const newsEnk = resolve => require(['@/components/newsDetail/newsEn11'], resolve)
const newsEnl = resolve => require(['@/components/newsDetail/newsEn12'], resolve)
Vue.use(Router)
export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/homeWeb',
      name: 'homeWeb',
      component: homeWeb,
      alias: '/'
    },
    {
      path: '/intelligent',
      name: 'intelligent',
      component: intelligent
    },
    {
      path: '/enterpriseNews',
      name: 'enterpriseNews',
      component: enterpriseNews
    },
    {
      path: '/joinus',
      name: 'joinus',
      component: joinus
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    {
      path: '/newsa',
      name: 'newsa',
      component: newsa
    },
    {
      path: '/newsb',
      name: 'newsb',
      component: newsb
    },
    {
      path: '/newsc',
      name: 'newsc',
      component: newsc
    },
    {
      path: '/newsd',
      name: 'newsd',
      component: newsd
    },
    {
      path: '/newse',
      name: 'newse',
      component: newse
    },
    {
      path: '/newsf',
      name: 'newsf',
      component: newsf
    },
    {
      path: '/newsg',
      name: 'newsg',
      component: newsg
    },
    {
      path: '/newsh',
      name: 'newsh',
      component: newsh
    },
    {
      path: '/newsi',
      name: 'newsi',
      component: newsi
    },
    {
      path: '/newsj',
      name: 'newsj',
      component: newsj
    },
    {
      path: '/newsk',
      name: 'newsk',
      component: newsk
    },
    {
      path: '/newsl',
      name: 'newsl',
      component: newsl
    },
    {
      path: '/newsm',
      name: 'newsm',
      component: newsm
    },
    {
      path: '/newsn',
      name: 'newsn',
      component: newsn
    },
    {
      path: '/newso',
      name: 'newso',
      component: newso
    },
    {
      path: '/newsp',
      name: 'newsp',
      component: newsp
    },
    {
      path: '/newsq',
      name: 'newsq',
      component: newsq
    },
    {
      path: '/newsr',
      name: 'newsr',
      component: newsr
    },
    {
      path: '/newss',
      name: 'newss',
      component: newss
    },
    {
      path: '/newst',
      name: 'newst',
      component: newst
    },
    {
      path: '/newsu',
      name: 'newsu',
      component: newsu
    },
    {
      path: '/newsv',
      name: 'newsv',
      component: newsv
    },
    {
      path: '/newsw',
      name: 'newsw',
      component: newsw
    },
    {
      path: '/newsx',
      name: 'newsx',
      component: newsx
    },
    {
      path: '/newsy',
      name: 'newsy',
      component: newsy
    },
    {
      path: '/newsz',
      name: 'newsz',
      component: newsz
    },
    {
      path: '/newsEna',
      name: 'newsEna',
      component: newsEna
    },
    {
      path: '/newsEnb',
      name: 'newsEnb',
      component: newsEnb
    },
    {
      path: '/newsEnc',
      name: 'newsEnc',
      component: newsEnc
    },
    {
      path: '/newsEnd',
      name: 'newsEnd',
      component: newsEnd
    },
    {
      path: '/newsEne',
      name: 'newsEne',
      component: newsEne
    },
    {
      path: '/newsEnf',
      name: 'newsEnf',
      component: newsEnf
    },
    {
      path: '/newsEng',
      name: 'newsEng',
      component: newsEng
    },
    {
      path: '/newsEnh',
      name: 'newsEnh',
      component: newsEnh
    },
    {
      path: '/newsEni',
      name: 'newsEni',
      component: newsEni
    },
    {
      path: '/newsEnj',
      name: 'newsEnj',
      component: newsEnj
    },
    {
      path: '/newsEnk',
      name: 'newsEnk',
      component: newsEnk
    },
    {
      path: '/newsEnl',
      name: 'newsEnl',
      component: newsEnl
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js